import axios from "axios";

// API Local: "http://localhost:8010/api/"

const axiosAPI = axios.create({
  baseURL: "http://api.easyvog.com.br/api/",
  timeout: 300000, // 5 minutes,
});

axiosAPI.interceptors.response.use(
  function (response) {
    return response;
  },
  function (error) {
    if (error.response.status === 401) {
      localStorage.removeItem("token");
      localStorage.removeItem("user");
      axiosAPI.defaults.headers.Authorization = undefined;
      
      window.location.replace("/login");
    }

    // Detectar erro de plano FREE expirado
    if (error.response && error.response.data) {
      const errorMessage = error.response.data.message || error.response.data.error || '';
      
      // Verificar se é mensagem de FREE expirado
      if (errorMessage.includes('período gratuito') && errorMessage.includes('expirou')) {
        // Atualizar dados do usuário no localStorage para refletir expiração
        const user = localStorage.getItem('user');
        if (user && user !== 'undefined') {
          try {
            const userData = JSON.parse(user);
            userData.is_free_expired = true;
            localStorage.setItem('user', JSON.stringify(userData));
            
            // Disparar evento customizado para notificar componentes React
            // Isso permite que os componentes reajam sem precisar de reload
            window.dispatchEvent(new CustomEvent('freePlanExpired', {
              detail: { 
                message: errorMessage,
                userData: userData 
              }
            }));
            
          } catch (e) {
            console.error('Erro ao atualizar dados do usuário:', e);
          }
        }
      }
    }

    return Promise.reject(error.response);
  }
);

export default axiosAPI;
